export default __webpack_public_path__ + "static/media/power.e8062931.svg";